import React from "react"
import {breakpoints} from "@next/ux-fabric"
import {useMediaQuery} from "../../../../hooks/useMediaQuery"
import {BannerInnerContainer, CountrySelectContainer, StyledDivider} from "./components"
import CountryLangSelector from "../../../CountryLangSelector"
import {COUNTRY_SELECTOR_DRAWER_BREAKPOINT} from "../../../../config/constants"

export const ClubStaticBannerInnerContainer = ({children, hasQuickLinks, countrySelectEnabled}) => {
    const isMobile = useMediaQuery(`(max-width:${breakpoints.values.md}px)`)
    const isOpeningFromBottom = !useMediaQuery(`(min-width:${COUNTRY_SELECTOR_DRAWER_BREAKPOINT})`)

    return (
        <BannerInnerContainer>
            {children}
            <CountrySelectContainer>
                {/* Needs to hide when there is no country select or no quickLinks */}
                {(hasQuickLinks && countrySelectEnabled) || (!hasQuickLinks && countrySelectEnabled && isMobile) ? (
                    <StyledDivider orientation="vertical" variant={isMobile ? "fullWidth" : "middle"} flexItem />
                ) : null}
                <CountryLangSelector isOpeningFromBottom={isOpeningFromBottom} />
            </CountrySelectContainer>
        </BannerInnerContainer>
    )
}

export default ClubStaticBannerInnerContainer
